import React, { useState, useEffect } from 'react';
import * as exportApi from '../../api/csv_export';
import { decode } from 'base64-arraybuffer';
import { formatDateForXLSXFileName } from '../../utils/date';
import { LoadingDots } from '../common/loading_dots';
import { faFileXls } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSessionState } from '../../hooks/use_session_state';
import { Button } from '../common/button';
import { Modal } from '../common/modal';

interface INHProps {
    orgNHID: number;
}

const OrgXLSXExport = (props: INHProps) => {
    const [exportRunning, setExportRunning] = useState<boolean>(false);
    const sessionState = useSessionState();

    const setFileName = () => {
        if (!sessionState.Org.Name) {
            return `${
                props.orgNHID
            } - Facility Details ( ${formatDateForXLSXFileName()} ).xlsx`;
        }
        return `${
            sessionState.Org.Name
        } - Facility Details ( ${formatDateForXLSXFileName()} ).xlsx`;
    };

    useEffect(() => {
        (async () => {
            if (!exportRunning) {
                return;
            }

            const excelFileName = setFileName();
            try {
                await exportApi.getXLSXExportFile(props.orgNHID).then(data => {
                    if (data?.data) {
                        const parsedData = decode(data.data);
                        const url = window.URL.createObjectURL(
                            new Blob([parsedData], {
                                type: ''
                            })
                        );
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', excelFileName);
                        document.body.appendChild(link);
                        link.click();
                    }
                });
            } catch (e) {
                console.error(`Excel Export data error: ${e}`);
            }
            setExportRunning(false);
        })();
    }, [exportRunning]);

    const startExport = async () => {
        setExportRunning(true);
    };

    const renderExportModal = () => {
        if (!exportRunning) {
            return;
        }
        let title = 'Exporting XLSX File';

        if (sessionState.Org.Name) {
            title = `Exporting ${sessionState.Org.Name} XLSX File`;
        }

        return (
            <Modal
                onClose={() => {}}
                size="sm"
                isOpen={true}
                footerContentClose={false}
                title={title}
            >
                 <div className='min-h-28'>
                    <h5>Preparing export. This may take a few minutes...</h5>
                    <br/>
                    <LoadingDots show={true}/>
                </div>
            </Modal>
        );
    };

    return (
        <>
            {
                <div className="col mt-2 lg:mt-0 mb-4 sm:mb-5">
                    <Button
                        className="btn btn-outline btn-outline-tertiary"
                        onClick={() => startExport()}
                        disabled={exportRunning}
                    >
                        <FontAwesomeIcon
                            icon={faFileXls}
                            className="text-3xl me-2"
                        />
                        Export Profile Content
                    </Button>
                </div>
            }

            {renderExportModal()}
        </>
    );
};

export default OrgXLSXExport;
